import script from "./sw-item-editor-phonenumber.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-editor-phonenumber.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-editor-phonenumber.vue?vue&type=style&index=0&id=3c03d204&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c03d204"]])

export default __exports__